/**
 * 数据中台（增长数据域）共享 Zod schema — 读侧看板时间窗闭集 + app_scope 查询参数
 *
 * 契约对齐 docs/data-ops-platform-design-2026-07-10.md §4-§6。/api/v1/metrics/* 只读端点
 * （monetization / engagement / diagnosis 等）的 range / app_scope query 参数在此单一定义，前后端共用。
 */

import { z } from 'zod';

/** 读侧看板时间窗闭集（对齐 dashboard DASHBOARD_RANGES）：当期 = [now-range, now)（UTC 日粒度） */
export const METRICS_RANGES = ['24h', '7d', '30d', '90d'] as const;
export const metricsRangeSchema = z.enum(METRICS_RANGES);
export type MetricsRange = z.infer<typeof metricsRangeSchema>;

/**
 * app_scope：'all' 或 apps.id（UUID 字符串）。UUID 归一小写：`z.string().uuid()` 接受大写十六进制，
 * 归一后同一 App 只有一种写法，下游缓存键 / 收入查询键不因大小写分裂（只读端点按 apps.id uuid 列
 * 过滤，PG uuid 本身大小写不敏感）。
 */
export const appScopeSchema = z
  .union([z.literal('all'), z.string().uuid()])
  .transform((s) => (s === 'all' ? 'all' : s.toLowerCase()));
export type MetricsAppScope = z.infer<typeof appScopeSchema>;
